import { Button } from "../../ui/button/index.js";
import { AppNotice } from "../AppNotice.js";
import { cn } from "../../../lib/utils.js";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  layout?: "page" | "panel";
}

export function ErrorState({
  message,
  onRetry,
  retryLabel,
  layout = "page",
}: ErrorStateProps): React.JSX.Element {
  return (
    <div className={cn(layout === "page" && "grid min-h-screen place-items-center px-6 py-8")}>
      <AppNotice
        severity="error"
        description={<p className="m-0">{message}</p>}
        className="max-w-md"
        action={
          onRetry ? (
            <Button type="button" size="sm" variant="outline" onClick={onRetry}>
              {retryLabel}
            </Button>
          ) : null
        }
      />
    </div>
  );
}
